export const pageQuery = `query ($site: String!, $path: String, $pageId: String, $device: Device!, $includeContent: Boolean, $moduleLimit: Int, $moduleOffset: Int, $languageCode: String, $countryCode: String, $userState: String, $modules: [String!], $offset: Int) {
  page(
    site: $site
    path: $path
    pageId: $pageId
    device: $device
    includeContent: $includeContent
    moduleLimit: $moduleLimit
    moduleOffset: $moduleOffset
    languageCode: $languageCode
    countryCode: $countryCode
    userState: $userState
    modules: $modules
    offset: $offset
  ) {
    id
    moduleCount
    moduleIds
    title
    metadataMap {
      title
      keywords
      description
      h1Title
      h2Title
      contentType
      contentUrl
      image
      isLiveStream
      duration
      uploadDate
      thumbnailUrl {
        r16x9
      }
    }
    modules {
      id
      moduleType
      ... on MastheadModule {
        setting {
          hideDate
        }
        layout {
          ...Layout
          ...PartialFonts
        }
      }
      ... on TextModule {
        rawText
        metadataMap
        layout {
          ...Layout
        }
      }
      ... on SearchModule {
        metadataMap
        layout {
          ...Layout
          ...PartialFonts
        }
      }
      ...on HistoryModule {
        id
        title
        metadataMap
         layout {
          ...Layout
          ...PartialFonts
        }
      }
      ...on QueueModule {
        id
        title
        metadataMap
         layout {
          ...Layout
          ...PartialFonts
        }
      }
      ...on ShowDetailModule {
        id
        metadataMap
        contentData {
          id
          gist {
            id
            title
            contentType
            permalink
            imageGist {
              r32x9
              r16x9
              r4x3
              r3x4
              r1x1
              r9x16
            }
          }
          ... on Series {
            id
            title
            seasons {
              title
              episodes {
                id
                title
                gist {
                  id
                  title
                  description
                  contentType
                  permalink
                  imageGist {
                    r32x9
                    r16x9
                    r4x3
                    r3x4
                    r1x1
                    r9x16
                  }
                }
              }
            }
          }
        }
         layout {
          ...Layout
        }
      }
      ... on GameDetailModule {
        title
        metadataMap
        contentData {
          id
          gist {
            id
            title
            contentType
            permalink
            imageGist {
              r32x9
              r16x9
              r4x3
              r3x4
              r1x1
              r9x16
            }
          }
          ... on Game {
            id
            ticketUrl
            gist {
              id
              title
              contentType
              permalink
              imageGist {
                r32x9
                r16x9
                r4x3
                r3x4
                r1x1
                r9x16
              }
            }
            preview {
              id
              gist {
                id
                title
                  imageGist {
                    r32x9
                    r16x9
                    r4x3
                    r3x4
                    r1x1
                    r9x16
                  }
              }
              monetizationModels{
                id,
                type
              }
              plans{
                type,
                planIds,
                planGroupIds
              }
            }
            currentState
            schedules {
              startDate
              endDate
            }
            league {
              id
              title
            }
            score{
              status
              type
              number
              homePoint
              awayPoint
            }
            homeTeam {
              owner
              id
              shortName
              currentSeason
              records {
                PST {
                  win
                  loss
                }
                REG{
                  win
                  loss
                }
                PRE{
                  win
                  loss
                }
                PIT{
                  win
                  loss
                }
              }
              gist {
                id
                title
                imageGist {
                  r32x9
                  r16x9
                  r4x3
                  r3x4
                  r1x1
                  r9x16
                }
              }
            }
            related {
              id
              title
              runtime
              gist {
                id
                title
                imageGist {
                  r32x9
                  r16x9
                  r4x3
                  r3x4
                  r1x1
                  r9x16
                }
                permalink
              }
            }
            awayTeam {
              owner
              id
              shortName
              currentSeason
              records {
                PST {
                  win
                  loss
                }
                REG{
                  win
                  loss
                }
                PRE{
                  win
                  loss
                }
                PIT{
                  win
                  loss
                }
              }
              gist {
                id
                title
                imageGist {
                  r32x9
                  r16x9
                  r4x3
                  r3x4
                  r1x1
                  r9x16
                }
              }
            }
            livestreams {
              id
              title
              gist {
                imageGist {
                  r32x9
                  r16x9
                  r4x3
                  r3x4
                  r1x1
                  r9x16
                }
              }
              monetizationModels{
                id,
                type
              }
              plans{
                type,
                planIds,
                planGroupIds
              }
            }
            metadata {
              name
              value
            }
            sportsRadar{
              id
              seasonId
              widgetType
            }
            highlights {
              id
              runtime
              gist {
                id
                title
                contentType
                permalink
                imageGist {
                  r32x9
                  r16x9
                  r4x3
                  r3x4
                  r1x1
                  r9x16
                }
              }
            }
          }
        }
        layout {
          ...PartialFonts
          ...Layout
        }
      }
      ... on ArticleDetailModule {
        id
        title
        contentData {
          ... on Article {
            articleAssets {
              url
            }
            readTime
            summaryText
            gist {
              id
              description
              title
              contentType
              permalink
              imageGist {
                r32x9
                r16x9
                r4x3
                r3x4
                r1x1
                r9x16
              }
            }
            imageList{
              id
              name
              url
            }
            author {
              name
            }
          }
        }
        layout {
          ...PartialFonts
          ...Layout
        }
        metadataMap
      }

      ... on VideoPlaylistDetailModule {
        id
        contentData {
          id
          title
          gist {
            id
            contentType
            title
            permalink
            description
          }
          ... on VideoPlaylist {
            metadata{
              name
              value
            }
            videoList {
              gist {
                id
                title
                description
                permalink
                imageGist {
                  r32x9
                  r16x9
                  r4x3
                  r3x4
                  r1x1
                  r9x16
                }
              }
            }
          }
        }
        layout {
          ...PartialFonts
          ...Layout
        }
        metadataMap
      }
      ... on StandaloneVideoPlayerModule {
        title
        subtitle
        contentData {
          id
          ...PartialGist
          ... on Video {
            ...PartialVideo_1
          }
        }
        metadataMap
        layout {
          ...PartialFonts
          ...Layout
        }
      }
      ... on CuratedTrayModule {
        title
        subtitle
        contentType
        contentData {
          id
          ...PartialGist
          ... on Video {
            ...PartialVideo_1
            
          }
          ... on Game {
            ...PartialGameContent_1
          }
          ... on Article {
            readTime
            gist {
              id
              description
            }
            author {
              name
            }
          }
          ... on VideoPlaylist {
            videoList {
              id
            }
          }
        }
        metadataMap
        layout {
          ...PartialFonts
          ...Layout
        }
      }
      ... on TveActivateModule {
        id
        title
        metadataMap
        layout {
          ...Layout
        }
      }

      ... on RedeemModule {
        id
        title
        metadataMap
        layout {
          ...Layout
        }
      }
      ... on TveModule {
        id
        title
        metadataMap
        layout {
          ...Layout
        }
      }
      ... on GeneratedTrayModule {
        title
        subtitle
        contentData {
          id
          ...PartialGist
          ... on Video {
            ...PartialVideo_1
          }
          ... on Game {
            ...PartialGameContent_1
          }
          ... on Article {
            readTime
            author {
              name
            }
          }
        }
        metadataMap
        layout {
          ...PartialFonts
          ...Layout
        }
      }
      ... on SubscriptionModule {
        metadataMap
        layout {
          ...Layout
        }
      }
      ... on AuthenticationModule {
        metadataMap
        layout {
          ...Layout
        }
      }
      ... on UserManagementModule {
        metadataMap
        rawText
        layout {
          ...Layout
          fontSetting {
            tab {
              fontFamilyName
              fontSize
              fontWeight
            }
          }
        }
      }
      ... on VideoDetailModule {
        id
        moduleType
        metadataMap
        title
        contentData {
          id
          title
          gist {
            id
            contentType
            permalink
            title
            description
            imageGist {
              r16x9
            }
          }

          ...PartialVideo_1
          ...on Video {
            relatedVideos {
              id
              title
              gist {
                id
                contentType
                permalink
                title
                description
                imageGist {
                  r16x9
                }
              }
              ...PartialVideo_1
            }
          }
        
        }
        metadataMap
        layout {
          ...PartialFonts
          ...Layout
        }
      }
      ... on CategoryDetailModule {
        title
        contentData {
          id
          ...PartialGist
          ... on Video {
            ...PartialVideo_1
          }
        }
        layout {
          ...Layout
        }
      }
      ... on TagDetailModule {
        title
        contentData {
          id
          ...PartialGist
          ... on Video {
            ...PartialVideo_1
          }
        }
        layout {
          ...Layout
        }
      }
      ... on ViewPlanModule {
        description
        metadataMap
        layout {
          ...Layout
        }
      }
      ... on ScheduleModule {
        id
        title
        subtitle
        metadataMap
        contentData {
          id
          ...PartialGist
          ... on Game {
            ...PartialGameContent_1
          }
        }
        layout {
          ...Layout
          ...PartialFonts
        }
      }
      ... on FooterModule {
        layout {
          ...Layout
        }
      }
    }
  }
}
fragment PartialGist on Content {
  id
  gist {
    id
    title
    contentType
    permalink
    description
    description
    imageGist {
      r32x9
      r16x9
      r4x3
      r3x4
      r1x1
      r9x16
    }
  }
}
fragment PartialFonts on ModuleLayout {
  fontSetting {
    title {
      fontFamilyName
      fontSize
      fontWeight
    }
    trayItemTitle {
      fontFamilyName
      fontSize
      fontWeight
    }
    subtitle {
      fontFamilyName
      fontSize
      fontWeight
    }
    team {
      fontFamilyName
      fontSize
      fontWeight
    }
    button {
      fontFamilyName
      fontSize
      fontWeight
    }
    articleTitle {
      fontFamilyName
      fontSize
      fontWeight
    }
    articleDescription {
      fontFamilyName
      fontSize
      fontWeight
    }
    tab {
      fontFamilyName
      fontSize
      fontWeight
    }
    widget {
      fontFamilyName
      fontSize
      fontWeight
    }
    videoTitle {
      fontFamilyName
      fontSize
      fontWeight
    }
    videoDescription {
      fontFamilyName
      fontSize
      fontWeight
    }
    searchSuggestionTitle {
      fontFamilyName
      fontSize
      fontWeight
    }
    searchSuggestionDate {
      fontFamilyName
      fontSize
      fontWeight
    }
    navigation {
      fontFamilyName
      fontSize
      fontWeight
    }
  }
}
fragment PartialVideo_1 on Video {
  parentalRating
  runtime
  metadata {
    name
    value
  }
}
fragment Layout on ModuleLayout {
  id
  settings
  styles
  view
  type
  blockName
  isMasthead
}
fragment PartialGameContent_1 on Game {
  id
  author {
    name
  }
  gist {
    id
    title
  }
  livestreams {
    id
    title
  }
  metadata {
    name
    value
  }
  ticketUrl
  homeTeam {
    id
    title
    shortName
    currentSeason
    records {
      PST {
        win
        loss
      }
      REG{
        win
        loss
      }
      PRE{
        win
        loss
      }
      PIT{
        win
        loss
      }
    }
    gist {
      title
      description
      imageGist {
        r32x9
        r16x9
        r4x3
        r3x4
        r1x1
        r9x16
      }
    }
  }
  awayTeam {
    id
    title
    shortName
    currentSeason
    records {
      PST {
        win
        loss
      }
      REG{
        win
        loss
      }
      PRE{
        win
        loss
      }
      PIT{
        win
        loss
      }
    }
    gist {
      title
      description
      imageGist {
        r32x9
        r16x9
        r4x3
        r3x4
        r1x1
        r9x16
      }
    }
  }
  highlights {
    id
    title
  }
  webliveUrl
  currentState
  preview {
    id
  }
  schedules {
    startDate
    endDate
    venue {
      id
      title
    }
  }
  score {
    status
    type
    number
    homePoint
    awayPoint
  }
  broadcaster

}`
export const minifiedPageQuery = `query ($site: String!, $path: String, $pageId: String, $device: Device!, $includeContent: Boolean, $moduleLimit: Int, $moduleOffset: Int, $languageCode: String, $countryCode: String, $userState: String, $modules: [String!], $offset: Int) { page( site: $site path: $path pageId: $pageId device: $device includeContent: $includeContent moduleLimit: $moduleLimit moduleOffset: $moduleOffset languageCode: $languageCode countryCode: $countryCode userState: $userState modules: $modules offset: $offset ) { id moduleCount moduleIds title metadataMap { title keywords description h1Title h2Title contentType contentUrl image isLiveStream duration uploadDate thumbnailUrl { r16x9 } } modules { id moduleType ... on MastheadModule { setting { hideDate } layout { ...Layout ...PartialFonts } } ... on TextModule { rawText metadataMap layout { ...Layout } } ... on SearchModule { metadataMap layout { ...Layout ...PartialFonts } } ...on HistoryModule { id title metadataMap layout { ...Layout ...PartialFonts } } ...on QueueModule { id title metadataMap layout { ...Layout ...PartialFonts } } ...on ShowDetailModule { id metadataMap contentData { id gist { id title contentType permalink imageGist { r32x9 r16x9 r4x3 r3x4 r1x1 r9x16 } } ... on Series { id title seasons { title episodes { id title gist { id title description contentType permalink imageGist { r32x9 r16x9 r4x3 r3x4 r1x1 r9x16 } } } } } } layout { ...Layout } } ... on GameDetailModule { title metadataMap contentData { id gist { id title contentType permalink imageGist { r32x9 r16x9 r4x3 r3x4 r1x1 r9x16 } } ... on Game { id ticketUrl gist { id title contentType permalink imageGist { r32x9 r16x9 r4x3 r3x4 r1x1 r9x16 } } preview { id gist { id title imageGist { r32x9 r16x9 r4x3 r3x4 r1x1 r9x16 } } monetizationModels{ id, type } plans{ type, planIds, planGroupIds } } currentState schedules { startDate endDate } league { id title } score{ status type number homePoint awayPoint } homeTeam { owner id shortName currentSeason records { PST { win loss } REG{ win loss } PRE{ win loss } PIT{ win loss } } gist { id title imageGist { r32x9 r16x9 r4x3 r3x4 r1x1 r9x16 } } } related { id title runtime gist { id title imageGist { r32x9 r16x9 r4x3 r3x4 r1x1 r9x16 } permalink } } awayTeam { owner id shortName currentSeason records { PST { win loss } REG{ win loss } PRE{ win loss } PIT{ win loss } } gist { id title imageGist { r32x9 r16x9 r4x3 r3x4 r1x1 r9x16 } } } livestreams { id title gist { imageGist { r32x9 r16x9 r4x3 r3x4 r1x1 r9x16 } } monetizationModels{ id, type } plans{ type, planIds, planGroupIds } } metadata { name value } sportsRadar{ id seasonId widgetType } highlights { id runtime gist { id title contentType permalink imageGist { r32x9 r16x9 r4x3 r3x4 r1x1 r9x16 } } } } } layout { ...PartialFonts ...Layout } } ... on ArticleDetailModule { id title contentData { ... on Article { articleAssets { url } readTime summaryText gist { id description title contentType permalink imageGist { r32x9 r16x9 r4x3 r3x4 r1x1 r9x16 } } imageList{ id name url } author { name } } } layout { ...PartialFonts ...Layout } metadataMap } ... on VideoPlaylistDetailModule { id contentData { id title gist { id contentType title permalink description } ... on VideoPlaylist { metadata{ name value } videoList { gist { id title description permalink imageGist { r32x9 r16x9 r4x3 r3x4 r1x1 r9x16 } } } } } layout { ...PartialFonts ...Layout } metadataMap } ... on StandaloneVideoPlayerModule { title subtitle contentData { id ...PartialGist ... on Video { ...PartialVideo_1 } } metadataMap layout { ...PartialFonts ...Layout } } ... on CuratedTrayModule { title subtitle contentType contentData { id ...PartialGist ... on Video { ...PartialVideo_1 } ... on Game { ...PartialGameContent_1 } ... on Article { readTime gist { id description } author { name } } ... on VideoPlaylist { videoList { id } } } metadataMap layout { ...PartialFonts ...Layout } } ... on TveActivateModule { id title metadataMap layout { ...Layout } } ... on RedeemModule { id title metadataMap layout { ...Layout } } ... on TveModule { id title metadataMap layout { ...Layout } } ... on GeneratedTrayModule { title subtitle contentData { id ...PartialGist ... on Video { ...PartialVideo_1 } ... on Game { ...PartialGameContent_1 } ... on Article { readTime author { name } } } metadataMap layout { ...PartialFonts ...Layout } } ... on SubscriptionModule { metadataMap layout { ...Layout } } ... on AuthenticationModule { metadataMap layout { ...Layout } } ... on UserManagementModule { metadataMap rawText layout { ...Layout fontSetting { tab { fontFamilyName fontSize fontWeight } } } } ... on VideoDetailModule { id moduleType metadataMap title contentData { id title gist { id contentType permalink title description imageGist { r16x9 } } ...PartialVideo_1 ...on Video { relatedVideos { id title gist { id contentType permalink title description imageGist { r16x9 } } ...PartialVideo_1 } } } metadataMap layout { ...PartialFonts ...Layout } } ... on CategoryDetailModule { title contentData { id ...PartialGist ... on Video { ...PartialVideo_1 } } layout { ...Layout } } ... on TagDetailModule { title contentData { id ...PartialGist ... on Video { ...PartialVideo_1 } } layout { ...Layout } } ... on ViewPlanModule { description metadataMap layout { ...Layout } } ... on ScheduleModule { id title subtitle metadataMap contentData { id ...PartialGist ... on Game { ...PartialGameContent_1 } } layout { ...Layout ...PartialFonts } } ... on FooterModule { layout { ...Layout } } } } } fragment PartialGist on Content { id gist { id title contentType permalink description description imageGist { r32x9 r16x9 r4x3 r3x4 r1x1 r9x16 } } } fragment PartialFonts on ModuleLayout { fontSetting { title { fontFamilyName fontSize fontWeight } trayItemTitle { fontFamilyName fontSize fontWeight } subtitle { fontFamilyName fontSize fontWeight } team { fontFamilyName fontSize fontWeight } button { fontFamilyName fontSize fontWeight } articleTitle { fontFamilyName fontSize fontWeight } articleDescription { fontFamilyName fontSize fontWeight } tab { fontFamilyName fontSize fontWeight } widget { fontFamilyName fontSize fontWeight } videoTitle { fontFamilyName fontSize fontWeight } videoDescription { fontFamilyName fontSize fontWeight } searchSuggestionTitle { fontFamilyName fontSize fontWeight } searchSuggestionDate { fontFamilyName fontSize fontWeight } navigation { fontFamilyName fontSize fontWeight } } } fragment PartialVideo_1 on Video { parentalRating runtime metadata { name value } } fragment Layout on ModuleLayout { id settings styles view type blockName isMasthead } fragment PartialGameContent_1 on Game { id author { name } gist { id title } livestreams { id title } metadata { name value } ticketUrl homeTeam { id title shortName currentSeason records { PST { win loss } REG{ win loss } PRE{ win loss } PIT{ win loss } } gist { title description imageGist { r32x9 r16x9 r4x3 r3x4 r1x1 r9x16 } } } awayTeam { id title shortName currentSeason records { PST { win loss } REG{ win loss } PRE{ win loss } PIT{ win loss } } gist { title description imageGist { r32x9 r16x9 r4x3 r3x4 r1x1 r9x16 } } } highlights { id title } webliveUrl currentState preview { id } schedules { startDate endDate venue { id title } } score { status type number homePoint awayPoint } broadcaster }`
export const pageQuerySHA = "caf84f2a1a72db28b48d94a2955200dfffac9a163452310429418107ef9ef989"
